<template>
  <v-autocomplete
    :value="value"
    :items="items"
    :multiple="multiple"
    :search-input.sync="search"
    :no-data-text="$t('TASKS.NO_DATA_FILTER_TEXT')"
    clearable
    cache-items
    v-bind="$attrs"
    v-on="listeners"
  >
    <template v-for="slot in Object.keys($scopedSlots)" v-slot:[slot]="scope">
      <slot :name="slot" v-bind="scope" />
    </template>
  </v-autocomplete>
</template>

<script>
import i18nRefreshData from '@/modules/_global/mixins/i18nRefreshData';
import autocomplete from './mixins/autocomplete';

export default {
  name: 'BaseAutocompleteFilter',

  mixins: [autocomplete, i18nRefreshData],

  inheritAttrs: false,

  mounted() {
    this.refreshData();
  },

  methods: {
    refreshData() {
      this.getData().then(items => {
        this.items = items;
      });
    },

    /**
     * Get data items
     *
     * @returns {Promise<never>}
     */
    getData() {
      return Promise.reject(new Error('"getData" function is not implemented'));
    }
  }
};
</script>
